import {
	FETCH_USER_PROFILE_INIT,
 	FETCH_USER_PROFILE_SUCCESS,
 	FETCH_USER_PROFILE_FAILURE,
  FETCH_USER_PROFILE_DISCONNECT_FITBIT_INIT,
  FETCH_USER_PROFILE_DISCONNECT_FITBIT_SUCCESS,
  FETCH_USER_PROFILE_DISCONNECT_FITBIT_FAILURE,
  FETCH_USER_PROFILE_RESET_TOURS_INIT,
  FETCH_USER_PROFILE_RESET_TOURS_SUCCESS,
  FETCH_USER_PROFILE_RESET_TOURS_FAILURE,
	RESET_USER_PROFILE,
 } from './types';
 import API from './api';

export function resetUserProfile() {
  return {
    type: RESET_USER_PROFILE,
  };
}

 function fetchApiSuccess(data) {
 	return {
 		type: FETCH_USER_PROFILE_SUCCESS,
 		payload: data,
 	};
 }

 function fetchApiFailure(error) {
 	return {
 		type: FETCH_USER_PROFILE_FAILURE,
 		payload: error,
 	};
 }

 function fetchApiInit() {
 	return {
 		type: FETCH_USER_PROFILE_INIT,
 	};
 }

 export function fetchUserProfileApi(filters) {
 	return async (dispatch) => {
 		dispatch(fetchApiInit());
 		try {
 			let data = await API.data.getAll(filters);
 			dispatch(fetchApiSuccess(data));
 		} catch (error) {
 			dispatch(fetchApiFailure(error));
 		}
 	};
 }

 export function connectFitbit(obj) {
  return async (dispatch) => {
    try {
      let data = await API.data.connectFitbit(obj);
    } catch (error) {}
  };
}

 function disconnectFitbitSuccess(data) {
  return {
    type: FETCH_USER_PROFILE_DISCONNECT_FITBIT_SUCCESS,
    payload: data,
  };
 }

 function disconnectFitbitFailure(error) {
  return {
    type: FETCH_USER_PROFILE_DISCONNECT_FITBIT_FAILURE,
    payload: error,
  };
 }

 function disconnectFitbitInit() {
  return {
    type: FETCH_USER_PROFILE_DISCONNECT_FITBIT_INIT,
  };
 }

 export function disconnectFitbit(filters) {
  return async (dispatch) => {
    dispatch(disconnectFitbitInit());
    try {
      let data = await API.data.disconnectFitbit(filters);
      dispatch(disconnectFitbitSuccess(data));
    } catch (error) {
      dispatch(disconnectFitbitFailure(error));
    }
  };
 }

  function resetToursSuccess(data) {
  return {
    type: FETCH_USER_PROFILE_RESET_TOURS_SUCCESS,
    payload: data,
  };
 }

 function resetToursFailure(error) {
  return {
    type: FETCH_USER_PROFILE_RESET_TOURS_FAILURE,
    payload: error,
  };
 }

 function resetToursInit() {
  return {
    type: FETCH_USER_PROFILE_RESET_TOURS_INIT,
  };
 }

 export function resetTours() {
  return async (dispatch) => {
    dispatch(resetToursInit());
    try {
      let data = await API.data.resetTours();
      dispatch(resetToursSuccess(data));
    } catch (error) {
      dispatch(resetToursFailure(error));
    }
  };
 }



// WEBPACK FOOTER //
// ./source/client/actions/user_profile/index.js